module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step1_Image12.763bbf70.webp";